//react
import { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";

//kendo
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { Pager } from '@progress/kendo-react-data-tools';
import { IntlProvider, load, loadMessages, LocalizationProvider } from '@progress/kendo-react-intl';
import { filterBy } from "@progress/kendo-data-query";
import kendo from "@progress/kendo-ui";
import { ProgressBar } from "@progress/kendo-react-progressbars";

//css
import './allStatus.css';
import styles from './allStatus.module.css';

//component
import AllStatusItem from './allStatusItem';
import AllStatusToolTip from './allStatusToolTip';
import { BeatLoader } from 'react-spinners';
import LocationLog from './locationLog';

//service
import { getFirstBizCnt, getUserStatCnt, getUserStatPage, getUserPattern, getUsers, getDangerYnCnt, setUpdateUserNote, getCoordinates, getDongCoordinates, getRgnCoordinates } from '../../../service/monitor/allStatusService';
import { getUserListData } from '../../../service/log/elderLogService';
import { getUser, isAdmin, isManager, isDeveloper } from '../../../service/authService';
import { getRgns, getDongs } from './../../../service/areaService';
import { getInstallStatAll } from '../../../service/monitor/installStatusService';
import { ElderInfoWindow } from '../installStatus/elderInfoWindow';
import { getUserInfo } from '../../../service/mobile/userInfoService';
import { roundNum } from '../../../com/dataUtil';
import useHistoryState from "../../../com/useHistoryState";

const AllStatus = ({ conn, qs, rgnList, dongList }) => {

  const userInfo = getUser();

  /* -------------------------------------------------------------- useState 및 변수  */
  const [loading, setLoading] = useState(false);
  const [dataState, setDataState] = useHistoryState({
    skip: 0,
    take: 4,
    // rgnCode: getUser().rgnCode,
    // dongCode: isManager() ? getUser().dongCode : '',
    meainStatCode: '',
    bizType: '',
    dangerElderYn: '',
    isNotPlan: '',
    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users : { userTerm: "대상자 선택", userId: "" },
    // 위험 대상자 구분
    dangerYnCnt: '',
  }, "search");
  const [dataSource, setDataSource] = useState({
    results: [],
    total: 0,
    rgnList: [], 
    dongList: [],
    userList: [],
    locationLogList: [],
  });
  const [statCntList, setStatCntList] = useState({
    totalCnt: 0,
    normalCnt: 0,
    warnCnt: 0,
    offCnt: 0,
    dangerCnt: 0,
    planCnt: 0,
    firstBizCnt: 0,
  });

  // 선택한 유저 정보
  const [selectUser, setSelectUser] = useState({})

  const [today, setToday] = useState(new Date());

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };
  const defaultValUser = { userTerm: "대상자 선택", userId: "" };

  /* Box 3 */

  // 맵
  const { kakao } = window;
  const mapContainer = useRef(null);
  const [mapType, setMapType] = useState("MEAIN");
  const [userInfoState, setUserInfoState] = useState("CLOSE");
  const [currentLocation, setCurrentLocation] = useState();
  let map;
  
  // 맵 레벨 설정
  const DEFAULT_MAP_LEVEL = 12;
  const history = useHistory();
  const AREA_CITY = "CITY";
  const AREA_RGN = "RGN";
  const AREA_DONG = "DONG";
  let DEFAULT_LATI = 36.81508; //위도
  let DEFAULT_LONGI = 127.11392; //경도

  rgnList.map(item => {
    if(item.rgnCode === userInfo.rgnCode) {
      DEFAULT_LATI = item.lati
      DEFAULT_LONGI = item.longi
    }
  })

  // 지도에 표시된 마커 객체
  let markers = useRef([]);

  // 처음 지도 설정
  const setLoadMap = () => {
    if(userInfo.userTypeCode === 2001) {
      loadMap(DEFAULT_LATI, DEFAULT_LONGI);
    } else if(userInfo.userTypeCode === 2002) {
      getDongCoordinates(conn, dataState)
      .then((result) => {
        loadMap(result.lat, result.lng);
      })
      .catch((err) => {
        console.log("getDongCoordinates Error = ", err);
      })
    } else if(userInfo.userTypeCode === 2003) {
      getRgnCoordinates(conn, dataState)
      .then((result) => {
        loadMap(result.lat, result.lng);
      })
      .catch((err) => {
        console.log("getRgnCoordinates Error = ", err);
      })
    } else {
      loadMap(DEFAULT_LATI, DEFAULT_LONGI);
    }
  }

  const loadMap = (lati, longi) => {
    setMapType("MEAIN");
    // 맵 설정
    map = new kakao.maps.Map(mapContainer.current, {
      //지도를 생성할 때 필요한 기본 옵션
      center: new kakao.maps.LatLng(lati, longi), //지도의 중심좌표.
      level: 6, //지도의 레벨(확대, 축소 정도)
    });
    // setMap(map);
    getInfoData(map)
    
    return () => {
      kakao.maps.event.removeListener(map);
    };
  }

  // 데이터 불러오기
  const getInfoData = (map, dongCode) => {
    setLoading(true);
    // dataState.dongCode = dongCode;
    getInstallStatAll(conn, dataState)
      .then(response => {
        response.forEach(item => {
          item.map = map;
        });
        // setDataSource(response);
        setMarker(map, response);
        setLoading(false);
      })
      .catch(error => console.log("getInstallStatAll Error", error));
  };

  // 마커 찍기
  const setMarker = (map, elderInfoList) => {
    removeMarkers();

    // 전체 데이터 가져와서 마커 찍기
    elderInfoList.forEach(elderInfo => {
      // 마커이미지의 주소입니다
      let imageSrc = "";
      if (elderInfo.dangerYn === "N") {
        if (elderInfo.meainStatCode === "20001") {
          imageSrc = "/images/chncareweb/marker_normal.png";
        } else if (elderInfo.meainStatCode === "20002") {
          imageSrc = "/images/chncareweb/marker_warn.png";
        } else if (elderInfo.meainStatCode === "20003") {
          imageSrc = "/images/chncareweb/marker_off.png";
        } else if (elderInfo.meainStatCode === "20004") {
          imageSrc = "/images/chncareweb/marker_danger.png";
        } else {
          imageSrc = "/images/chncareweb/marker_off.png";
        }
      } else {
        if (elderInfo.meainStatCode === "20001") {
          imageSrc = "/images/chncareweb/marker_normal_management.png";
        } else if (elderInfo.meainStatCode === "20002") {
          imageSrc = "/images/chncareweb/marker_warn_management.png";
        } else if (elderInfo.meainStatCode === "20003") {
          imageSrc = "/images/chncareweb/marker_off_management.png";
        } else if (elderInfo.meainStatCode === "20004") {
          imageSrc = "/images/chncareweb/marker_danger_management.png";
        } else {
          imageSrc = "/images/chncareweb/marker_off_management.png";
        }
      }

      //경도,위도 null값 예외처리
      if (!elderInfo.lat || !elderInfo.lng) return;
      const marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(parseFloat(elderInfo.lat), parseFloat(elderInfo.lng)),
        image: new kakao.maps.MarkerImage(imageSrc, new kakao.maps.Size(20, 32), { offset: new kakao.maps.Point(16.5, 32) }), // 마커이미지 설정
        clickable: true,
      });

      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);
      markers.current.push(marker);

      // 마우스 오버 콘텐츠
      const overWindow = new kakao.maps.InfoWindow({
        content: '<div class="kakaoMapMouseOverDiv">' + elderInfo.userTerm + "</div>",
      });

      // 마커 마우스 오버 인 이벤트
      const mouseOverEvt = () => {
        overWindow.open(map, marker);
      };
      kakao.maps.event.addListener(marker, "mouseover", mouseOverEvt);

      // 마커 마우스 오버 아웃 이벤트
      const mouseOutEvt = () => {
        overWindow.close();
      };
      kakao.maps.event.addListener(marker, "mouseout", mouseOutEvt);

      // 마커 클릭 콘텐츠
      const infoWindow = new kakao.maps.InfoWindow({
        // position : new kakao.maps.LatLng(elderInfo.lati, elderInfo.longi),
        content: ElderInfoWindow(elderInfo),
      });

      // 인포윈도우 위치 설정 왜그런지 모르겠지만 Qd, Nd 랜덤으로 뜸
      if (infoWindow.Qd) {
        infoWindow.Qd.width = -6.5;
        infoWindow.Qd.height = -3;
      } else if (infoWindow.Nd) {
        infoWindow.Nd.width = -6.5;
        infoWindow.Nd.height = -3;
      }

      // 마커 클릭 이벤트
      const clickMarker = () => {
        if (document.getElementsByName("closeInfoBtn")[0]) document.getElementsByName("closeInfoBtn")[0].click();
        const level = map.getLevel() >= 3 ? 3 : map.getLevel();
        map.setLevel(level);
        infoWindow.open(map, marker);
        createInfoWindow(map, marker, infoWindow, elderInfo);
        setMapPosition(parseFloat(elderInfo.lat), parseFloat(elderInfo.lng), map);
      };

      // 맵 클릭 이벤트
      kakao.maps.event.addListener(marker, "click", clickMarker);
    });
  };

  // 대상자 정보 열기
  const openUserInfo = () => {
    setUserInfoState("OPEN");
  }
  
  // 대상자 정보 닫기
  const closeUserInfo = () => {
    setUserInfoState("CLOSE");
  }

  // 현재 위치 이동
  const moveCurrentLocation = () => {
    if(currentLocation === undefined) {

    } else {
      currentLocation.map.setCenter(new kakao.maps.LatLng(parseFloat(currentLocation.lat), parseFloat(currentLocation.lng)))
    }
  }

  // infoWindow 창 제작
  const createInfoWindow = (map, marker, infowindow, element) => {
    infowindow.open(map, marker);
    //닫기(x) 버튼
    const closeBtn = document.getElementsByName("closeInfoBtn")[0];
    closeBtn.addEventListener("click", function () {
      infowindow.close();
    });

    //특이사항 수정 버튼
    const modifyBtn = document.getElementById("noteModiBtn");
    modifyBtn.addEventListener("click", function () {
      const elderInfoNote = document.getElementById("elderInfoNote");
      const dataItem = {
        userId: elderInfoNote.name,
        note: elderInfoNote.value,
      };
      kendo.confirm("특이사항을 수정하시겠습니까?").then(() => {
        setUpdateUserNote(conn, dataItem)
          .then(response => {
            kendo.alert("수정완료");
            getGridData();
          })
          .catch(error => console.log("특이사항 업데이트 오류", error));
      });
    });

    const moveInstaller = document.getElementsByName("informationBtn")[0];
    moveInstaller.addEventListener("click", function () {
      const dongCode = element.dongCode;
      const dongTermSimple = element.dongTermSimple;
      const elderTerm = element.userTerm;
      const elderId = element.userId;
      const startDtm = new Date();
      const endDtm = new Date();
      const radio = "HH";

      history.push({
        pathname: "/log/elder",
        state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
      });
    });
  };

  // 카카오 맵의 마커를 제어 (삭제)
  const removeMarkers = () => {
    for (let i = 0; i < markers.current.length; i++) {
      markers.current[i].setMap(null);
    }
    // 저장된 마커 전부 초기화
    if (dataState.dongCode === "") {
      markers.current = [];
    }
  };

  // 맵 좌표 요청 (맵 이동)
  const setMapPosition = (lati, longi, map) => {
    if (map) {
      if (!lati) {
        lati = DEFAULT_LATI;
      }
      if (!longi) {
        longi = DEFAULT_LONGI;
      }
      map.setCenter(new kakao.maps.LatLng(lati, longi));
    }
  };

  // 대상자 상태 지속시간
  const foramtDataStatTime = () => {
    let text = "미작동"
    let hour;
    let min;

    if(selectUser.latestDataStatTime) {
      hour = parseInt(selectUser.latestDataStatTime/60)
      min = selectUser.latestDataStatTime%60

      text = hour + "시간  " + min + "분"
    } else if (selectUser.meainStatCode == '20005') {
      text = "설치예정"
    }
    return <span className={styles.dataStatTime}>{text}</span>;
  }

  // 20001		정상
  // 20002		경고
  // 20003		미작동
  // 20004		위험
  // 20005		설치예정
  // 설비 이벤트
  const getMeainStat = () => {
    if ( selectUser.meainStatCode === "20001" ) {
      return <div className={styles.eventBox} id="normalBox">정상</div>
    } else if ( selectUser.meainStatCode === "20002" ) {
      return <div className={styles.eventBox} id="warnBox">경고</div>
    } else if ( selectUser.meainStatCode === "20003" ) {
      return <div className={styles.eventBox} id="offBox">미작동</div>
    } else if ( selectUser.meainStatCode === "20004" ) {
      return <div className={styles.eventBox} id="dangerBox">위험</div>
    } else {
      return <div className={styles.eventBox} id="planBox">설치예정</div>
    }
  }

  const rgnCode = selectUser.rgnCode;
  const rgnTermSimple = selectUser.rgnTermSimple;
  const dongCode = selectUser.dongCode;
  const dongTermSimple = selectUser.dongTermSimple;
  const elderTerm = selectUser.userTerm;
  const elderId = selectUser.userId;
  const startDtm = new Date();
  const endDtm = new Date();
  const radio = "HH";
  // 대상자 이력 이동
  const elderLogBtnClickEvt = () => {
    history.push({
      pathname: "/log/elder",
      state: { rgnCode, rgnTermSimple, dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
  };

  /* -------------------------------------------------------------- service 및 데이터 조회  */
  //대상자 페이징 데이터 조회
  const getGridData = () => {
    setLoading(true);
    if(dataState.meainStatCode === '20005') {
      dataState.isNotPlan = null
    } else {
      dataState.isNotPlan = 'Y'
    }
    getUserStatPage(conn, dataState)
      .then(response => {
        response.results.forEach(item => {
          if(item.bizType === "5003") {
            item.temperature -= 5;
            item.humidity += 10;
          }
        })
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.results = response.results;
          item.total = response.total;
          return item;
        })
        setLoading(false);
      })
      .catch(error => console.log('getUserStatPage Error', error));
  };

  //대상자 (정상, 경고, 위험, 미작동, 설치예정) 개수 조회
  const getStatCntList = () => {
    setLoading(true);
    getUserStatCnt(conn, dataState)
      .then(response => {
        const totalCnt = response.normalCnt + response.warnCnt + response.offCnt + response.dangerCnt + response.planCnt;
        response.totalCnt = totalCnt;
        setStatCntList(response);
      })
      .catch(error => console.log('getStatCnt Error', error));

    getDangerYnCnt(conn, dataState)
      .then(response => {
        setDataState(dataState => {
          const item = { ...dataState };
          item.dangerYnCnt = response;
          return item;
        })
      })
      .catch(err => console.log("getDangerYnCnt err = ", err));
  };

  // 초기 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
    // 대상자
    getUsers(conn, dataState)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        // item.userList = response;
        item.userList = response.filter(item => item.meainStatCode !== "20005");
        return item;
      })
      setData(response.slice());
    })
    .catch(error => {
      console.log("getUserList error = ", error);
    })
  }

  /* -------------------------------------------------------------- changeEvent clickEvent  */
  // 시군구, 읍면동, 대상자 드롭다운 체인지 이벤트
  const changeDropEvent = e => {
    if (e.target.name === "rgn") {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            // item.userList = response;
            item.userList = response.filter(item => item.meainStatCode !== "20005");
            return item;
          })
          setData(response.slice());
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });
    } else if (e.target.name === "dong") {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        // 하위 데이터 초기화
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            // item.userList = response;
            item.userList = response.filter(item => item.meainStatCode !== "20005");
            return item;
          })
          setData(response.slice());
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
    } else if (e.target.name === 'user') {
      // 드롭다운 검색조건 변경
      if(e.target.value.userTerm === "대상자 선택") {
        setDataState(dataState => {
          const item = { ...dataState };
          item.userId = e.target.value.userId;
          item.userTerm = "";
          item.users = e.target.value;
          return item;
        })
      } else {
        setDataState(dataState => {
          const item = { ...dataState };
          item.userId = e.target.value.userId;
          item.userTerm = e.target.value.userTerm;
          item.users = e.target.value;
          return item;
        })
      }
    }
  }

  const pageChangeEvt = e => {
    dataState.skip = e.skip;
    setDataState({ ...dataState, skip: e.skip });
    getGridData();
  };

  const searchBtnClickEvt = e => {

    if(dataState.userId) {
      // lati, longi 구해오기
      getCoordinates(conn, dataState)
      .then((result) => {
        loadMap(result.lat, result.lng);
      })
      .catch((err) => {
        console.log("getCoordinates Error = ", err);
      })
    } else if(dataState.dongCode) {
      dongList.find(data => {
        if (data.dongCode === dataState.dongCode) {    
          loadMap(data.lati, data.longi);
        }
      })
    } else if(dataState.rgnCode && !dataState.dongCode) {
      getRgnCoordinates(conn, dataState)
      .then((result) => {
        loadMap(result.lat, result.lng);
      })
      .catch((err) => {
        console.log("getRgnCoordinates Error = ", err)
      })
    } else {
      loadMap(DEFAULT_LATI, DEFAULT_LONGI);
    }


    initDataState();
    getGridData();
    getStatCntList();
  };

  const renewBtnClickEvt = e => {
    
    setLoadMap();
    renewData();
    getGridData();
    getStatCntList();
  };

  // 데이터 초기화
  const renewData = () => {
    dataState.skip = 0;
    dataState.take = 4;
    
    dataState.userId = "";
    dataState.userTerm = "";
    
    dataState.users = { userTerm: "대상자 선택", userId: "" };
    dataState.meainStatCode = '';
    dataState.bizType = '';
    dataState.dangerElderYn = '';

    if(userInfo.userTypeCode === 2005) {
      dataState.rgns = { rgnTermSimple: "시/군/구", rgnCode: "" };
      dataState.rgnCode = "";
      dataState.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
      dataState.dongCode = "";
    } else if(userInfo.userTypeCode === 2003) {
      dataState.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
      dataState.dongCode = "";
    } else {
    }
  }

  const initDataState = () => {
    dataState.skip = 0;
    dataState.take = 4;
    // dataState.userId = '';
    // dataState.userTerm = '';
    // dataState.dongCode = '';
    dataState.meainStatCode = '';
    dataState.bizType = '';
    dataState.dangerElderYn = '';
  };

  const allStatHeaderClickEvt = meainStatCode => {
    initDataState();
    getStatCntList();
    dataState.meainStatCode = meainStatCode;
    getGridData();
  };

 

  /* -------------------------------------------------------------- useEffect  */

  //90초마다 데이터 새로고침
  const resetData = () => {
    setTimeout(() => {
      setToday(new Date());
    }, 90000);
  };

  useEffect(() => {
    // resetData();
    // getGridData();
    getStatCntList();
    // getUserList();
    // setDongData(dongList);
  }, [today]);

  const [data, setData] = useState(dataSource.userList.slice());
  const filterData = (filter) => {
    const data = dataSource.userList.slice();
    return filterBy(data, filter);
  };
  const filterChange = (event) => {
    setData(filterData(event.filter));
  };

  useEffect(() => {
    getGridData();
    getStatCntList();
    getDataList();
    setLoadMap();
  }, []);

  /* -------------------------------------------------------------- return  */
  return (
    <div className={styles.allStatusContainer}>
      <div className={styles.allStatusBox1}>
        <p className={styles.allStatusBox1Title}>전체현황 목록</p>
        <div className={styles.allStatusBox1Content}>
          <div className={styles.content} id="total" onClick={() => {initDataState(); getStatCntList(); getGridData(); }}>
            <span className={styles.name}>총개소</span>
            <img src="/images/mobile/total2.png"></img>
            <span className={styles.cnt}>{statCntList.totalCnt}</span>
          </div>
          <div className={styles.content} id="normal" onClick={() => allStatHeaderClickEvt('20001')}>
            <span className={styles.name}>정상</span>
            <img src="/images/mobile/normal2.png"></img>
            <span className={styles.cnt}>{statCntList.normalCnt}</span>
          </div>
          <div className={styles.content} id="warn" onClick={() => allStatHeaderClickEvt('20002')}>
            <span className={styles.name}>경고</span>
            <img src="/images/mobile/warn2.png"></img>
            <span className={styles.cnt}>{statCntList.warnCnt}</span>
          </div>
          <div className={styles.content} id="danger" onClick={() => allStatHeaderClickEvt('20004')}>
            <span className={styles.name}>위험</span>
            <img src="/images/mobile/danger2.png"></img>
            <span className={styles.cnt}>{statCntList.dangerCnt}</span>
          </div>
          <div className={styles.content} id="off" onClick={() => allStatHeaderClickEvt('20003')}>
            <span className={styles.name}>미작동</span>
            <img src="/images/mobile/off2.png"></img>
            <span className={styles.cnt}>{statCntList.offCnt}</span>
          </div>
          <div className={styles.content} id="plan" onClick={() => allStatHeaderClickEvt('20005')}>
            <span className={styles.name} style={{color:'#444444', width: '60%'}}>설치예정</span>
            <span style={{color:'#444444'}} className={styles.cnt}>{statCntList.planCnt}</span>
          </div>
        </div>
      </div>
      <div className={styles.allStatusBox2}>
        <div className={styles.allStatusBox2Search}>
          {/* <span className={styles.searchTitle}>시군구</span> */}
          <DropDownList
            id="rgn"
            name="rgn"
            data={dataSource.rgnList}
            disabled={!isDeveloper() ? true : false}
            className="allStatusSearchDropdown"
            value={dataState.rgns}
            textField="rgnTermSimple"
            dataItemKey="rgnCode"
            defaultItem={defualtValRgn}
            onChange={changeDropEvent}
          />
          {/* <span className={styles.searchTitle}>읍면동</span> */}
          <DropDownList
            id="dong"
            name="dong"
            data={dataSource.dongList}
            disabled={!isAdmin() ? true : !dataState.rgnCode ? true : false}
            className="allStatusSearchDropdown"
            value={dataState.dongs}
            textField="dongTermSimple"
            dataItemKey="dongCode"
            defaultItem={defualtValDong}
            onChange={changeDropEvent}
          />
          {/* <span className={styles.searchTitle}>대상자</span> */}
          <DropDownList
            id="user"
            name="user"
            data={data}
            className="allStatusSearchDropdown"
            value={dataState.users}
            textField="userTerm"
            dataItemKey="userId"
            defaultItem={defaultValUser}
            onChange={changeDropEvent}
            filterable
            onFilterChange={filterChange}
          />
          <Button className={styles.searchButton} icon="search" onClick={searchBtnClickEvt}>조회</Button>
          <Button className={styles.searchButton} icon="refresh" onClick={renewBtnClickEvt}>리셋</Button>
        </div>
        <div className={styles.allStatusBox2Tooltip}>
          <AllStatusToolTip
            dataSource={dataSource}
            dataState={dataState}
            getGridData={getGridData}
            statCntList={statCntList}
            getStatCntList={getStatCntList}
            initDataState={initDataState}
            isDeveloper={isDeveloper}
          />
        </div>
        <div className={styles.allStatusBox2List}>
          {dataSource.results.length ? (
            dataSource.results.map(item => {
              return <AllStatusItem conn={conn} item={item} map={map} setSelectUser={setSelectUser} mapContainer={mapContainer}
               setMapType={setMapType} setUserInfoState={setUserInfoState} setDataSource={setDataSource} getGridData={getGridData}
               currentLocation={currentLocation} setCurrentLocation={setCurrentLocation}/>;
            })
          ) : (
            <div className={styles.noDataDiv}>데이터가 없습니다.</div>
          )}
        </div>
        <div className="uk-grid">
          <div className="uk-width-medium-1-1">
            <LocalizationProvider language={'ko-KR'}>
              <IntlProvider locale={'ko'}>
                <Pager skip={dataState.skip} take={dataState.take} onPageChange={pageChangeEvt} previousNext={true} total={dataSource.total} buttonCount={8} info={true} type="numeric"></Pager>
              </IntlProvider>
            </LocalizationProvider>
          </div>
        </div>
      </div>
      <div className={styles.allStatusBox3}>
        <div ref={mapContainer} style={{ width: "100%", height: "100%" }}></div>
        {
          mapType === "MEAIN" ? 
            null 
            :
            userInfoState === "OPEN" ?
              <>
                <div className={styles.userInfoButton} onClick={closeUserInfo}>대상자 정보 닫기</div>
                <div className={styles.userLocationButton} onClick={moveCurrentLocation}><img style={{width: "25px", height: "25px"}} src="/images/currentLocation_white.png"></img></div>
                <div className={styles.userInfo}>
                  <div className={styles.basicInfo}>
                    <span className={styles.userTerm}>{selectUser.userTerm} 어르신</span>
                    <span className={styles.date}>{kendo.toString(new Date(),"yyyy.MM.dd")}</span>
                  </div>

                  <div className={styles.rawInfo}>
                    <div className={styles.rawInfoTitle}>수집 정보</div>
                    <div className={styles.rawInfoDiv}>
                      <img src="/images/mobile/icon_10.png"></img>
                      <div className={styles.dataDiv}>
                        <span className={styles.dataName}>활동량</span>
                        {selectUser.bizType === "5003" ?
                        <span className={styles.dataValue}>{selectUser.velocityTotal !== undefined && selectUser.velocityTotal !== null ? roundNum(selectUser.velocityTotal, 2) : "-"}</span>
                        :
                        <span className={styles.dataValue}>{selectUser.movement !== undefined && selectUser.movement !== null ? roundNum(selectUser.movement, 2) : "-"}</span>
                        }
                      </div>
                      {selectUser.bizType === "5003" ? 
                      <ProgressBar className="rawInfoProgressbar" value={selectUser.velocityTotal} labelVisible={false} max={3000}/>
                      :
                      <ProgressBar className="rawInfoProgressbar" value={selectUser.movement} labelVisible={false} max={500}/>
                      }
                    </div>
                    <div className={styles.rawInfoDiv}>
                      <img src="/images/mobile/icon_11.png"></img>
                      <div className={styles.dataDiv}>
                        <span className={styles.dataName}>온도</span>
                        <span className={styles.dataValue}>{selectUser.temperature !== undefined && selectUser.temperature !== null ? roundNum(selectUser.temperature, 2) : "-"} °C</span>
                      </div>
                      <ProgressBar className="rawInfoProgressbar" value={selectUser.temperature} labelVisible={false} max={50}/>
                    </div>
                    <div className={styles.rawInfoDiv}>
                      <img src="/images/mobile/icon_12.png"></img>
                      <div className={styles.dataDiv}>
                        <span className={styles.dataName}>습도</span>
                        <span className={styles.dataValue}>{selectUser.humidity !== undefined && selectUser.humidity !== null ? roundNum(selectUser.humidity, 2) : "-"} %</span>
                      </div>
                      <ProgressBar className="rawInfoProgressbar" value={selectUser.humidity} labelVisible={false} max={90}/>
                    </div>
                    <div className={styles.rawInfoDiv}>
                      <img src="/images/mobile/icon_14.png"></img>
                      <div className={styles.dataDiv}>
                        <span className={styles.dataName}>조도</span>
                        <span className={styles.dataValue}>{selectUser.light !== undefined && selectUser.light !== null ? roundNum(selectUser.light, 2) : "-"} Lx</span>
                      </div>
                      <ProgressBar className="rawInfoProgressbar" value={selectUser.light} labelVisible={false} max={500}/>
                    </div>
                  </div>

                  <div className={styles.locationInfo}>
                    <div className={styles.locationInfoTitle}>위치 경로</div>
                    {dataSource.locationLogList.length ? (
                      dataSource.locationLogList.map((item, index) => {
                        const lastIndex = dataSource.locationLogList.length -1;
                        return <LocationLog conn={conn} item={item} index={index} lastIndex={lastIndex} selectUser={selectUser}/>
                      })
                    ) : (
                      <div className={styles.noDataDiv}>위치 정보가 없습니다.</div>
                    )}
                  </div>

                </div>
              </>
              :
              <>
                <div className={styles.userInfoButton} onClick={openUserInfo}>대상자 정보 열기</div>
                <div className={styles.userLocationButton} onClick={moveCurrentLocation}><img style={{width: "25px", height: "25px"}} src="/images/currentLocation_white.png"></img></div>
              </>
        }
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={24} color="#1e88e5" />
        </p>
      )}
    </div>
  );
};
export default AllStatus;